export const SET_SAMPLE = '@SAMPLE_MANAGEMENT/SET_SAMPLE';
export const SET_CONSORTIUM_DATA = '@SAMPLE_MANAGEMENT/SET_CONSORTIUM_DATA';
export const SET_CENTRE_LEARNERS = '@SAMPLE_MANAGEMENT/SET_CENTRE_LEARNERS';
export const SET_IS_SAMPLE_BEING_RERUN = '@SAMPLE_MANAGEMENT/SET_IS_SAMPLE_BEING_RERUN';
export const SET_IS_SAMPLE_LOADING = '@SAMPLE_MANAGEMENT/SET_IS_SAMPLE_LOADING';
export const SET_IS_ENTRIES_LOADING = '@SAMPLE_MANAGEMENT/SET_IS_ENTRIES_LOADING';
export const SET_ERROR = '@SAMPLE_MANAGEMENT/SET_ERROR';
export const SET_IS_ENTRIES_PATCHING = '@SAMPLE_MANAGEMENT/SET_IS_ENTRIES_PATCHING';
export const RESET_STATE = '@SAMPLE_MANAGEMENT/RESET_STATE';
export const RESET_STATE_FULL = '@SAMPLE_MANAGEMENT/RESET_STATE_FULL';
export const SET_SAMPLE_SEARCH_PARAMS = '@SAMPLE_MANAGEMENT/SET_SAMPLE_SEARCH_PARAMS';
export const SET_ALGO_RERUNS = '@SAMPLE_MANAGEMENT/SET_ALGO_RERUNS';

import { Series, Consortium, AlgoRerunDto, Sample } from '@cambridgeassessment/lib-ee-commons';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db/entries';

export interface SampleSearchParams {
  series?: Series;
  assessmentCode?: string;
  centreId?: string;
  componentNumber?: string;
  businessUnit?: string;
}

export interface SetSample {
  type: typeof SET_SAMPLE;
  payload: {
    sample: Sample;
  };
}

export interface SetSampleSearchParams {
  type: typeof SET_SAMPLE_SEARCH_PARAMS;
  payload: {
    sampleSearchParams: SampleSearchParams;
  };
}

export interface SetConsortiumData {
  type: typeof SET_CONSORTIUM_DATA;
  payload: {
    consortium: Consortium;
  };
}

export interface SetCentreLearners {
  type: typeof SET_CENTRE_LEARNERS;
  payload: {
    centreLearners: Entry[];
  };
}

export interface SetAlgoReruns {
  type: typeof SET_ALGO_RERUNS;
  payload: {
    algoReruns: AlgoRerunDto[];
  };
}

export interface SetIsSampleLoading {
  type: typeof SET_IS_SAMPLE_LOADING;
  payload: { value: boolean };
}
export interface SetIsEntriesLoading {
  type: typeof SET_IS_ENTRIES_LOADING;
  payload: { value: boolean };
}

export interface SetIsLearnersPatching {
  type: typeof SET_IS_ENTRIES_PATCHING;
  payload: { value?: boolean };
}
export interface ResetState {
  type: typeof RESET_STATE;
}
export interface ResetStateFull {
  type: typeof RESET_STATE_FULL;
}
export interface SetIsSampleBeingRerun {
  type: typeof SET_IS_SAMPLE_BEING_RERUN;
  payload: { value: boolean };
}

export interface SetError {
  type: typeof SET_ERROR;
}

export type SamplesManagementActionTypes =
  | SetSample
  | SetCentreLearners
  | SetIsSampleLoading
  | SetError
  | SetIsLearnersPatching
  | SetIsEntriesLoading
  | SetConsortiumData
  | SetSampleSearchParams
  | ResetState
  | ResetStateFull
  | SetIsSampleBeingRerun
  | SetAlgoReruns;
